import React from "react";

import {
  CustomTooltipWrapper,
  CustomTooltipLi,
} from "../../dashboard-tabs/insurance-premium-portfolio/insurance-premium-portfolio-chart-styles";
import { MONTHS_FULL_NAMES } from "../../../../../constants/dates";
import { formatNumber } from "../../dashboard-utils";
import { deepGet } from "../../../../../utils/utility";
import { CustomTooltipProps, TooltipPayload } from "../../clients-dashboard-types";

const ChartCustomTooltip = ({ active, payload, label, withoutZero }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const year = deepGet(payload, "0.payload.year", "");
    const fullMonthLabel = MONTHS_FULL_NAMES[label];

    return (
      <CustomTooltipWrapper>
        <ul className="recharts-tooltip-item-list">
          {`${year} - ${fullMonthLabel}`}
          {payload.map((item: TooltipPayload, index: number) => {
            const number = formatNumber(item.value);
            if (withoutZero && number === "0") return null;
            return (
              <CustomTooltipLi
                className="recharts-tooltip-item"
                key={`tooltip-item-${index}`}
                color={item.color}
              >
                <span className="recharts-tooltip-item-name">{item.name}</span> :{" "}
                <span className="recharts-tooltip-item-value">{number}</span>
              </CustomTooltipLi>
            );
          })}
        </ul>
      </CustomTooltipWrapper>
    );
  }
  return null;
};

export default ChartCustomTooltip;
